export const CROP_WINDOW_WIDTH = 320;
export const CROP_WINDOW_HEIGHT = 320;

export const CANVAS_EMPTY = "CANVAS_EMPTY";
export const CANVAS_CREATION_ERROR = "CANVAS_CREATION_ERROR";
export const IMAGE_CREATION_ERROR = "IMAGE_CREATION_ERROR";
export const MAX_USER_IMAGE_SIZE_IN_MB = 20;

type SetFileBlobURLOrErrorReturn =
    | {
          success: boolean;
          msg: string;
      }
    | undefined;

export const setFileBlobURLOrError = ({
    event,
}: {
    event: React.ChangeEvent<HTMLInputElement>;
}): SetFileBlobURLOrErrorReturn => {
    if (event.target.files && event.target.files.length > 0) {
        const formatRegExp = new RegExp(`^image/([a-z])*$`, "i");
        const {type, size} = event.target.files[0];
        const maxAllowedSize = MAX_USER_IMAGE_SIZE_IN_MB * 1024 * 1024;
        const isValid = formatRegExp.test(type);
        const fileBlob = event.target.files[0];
        const input = event.target;
        input.value = "";
        if (isValid && size <= maxAllowedSize) {
            const URL = window.URL || window.webkitURL;
            const fileURL = URL.createObjectURL(fileBlob);
            return {success: true, msg: fileURL};
        } else {
            const error =
                size > maxAllowedSize
                    ? `Image size exceeds ${MAX_USER_IMAGE_SIZE_IN_MB}MB. Please try again with smaller size.`
                    : `Invalid image format. Acceptable image formats are jpg, jpeg, png.`;
            return {success: false, msg: error};
        }
    }
};

const createImage = (url: string) =>
    new Promise<HTMLImageElement>((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", () => resolve(image));
        image.addEventListener("error", (error) => reject(error));
        image.src = url;
    });

export default async function getCroppedImg(
    imageSrc: string,
    crop: {width: number; height: number; x: number; y: number},
): Promise<string | Blob> {
    try {
        const image = await createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = CROP_WINDOW_WIDTH;
        canvas.height = CROP_WINDOW_HEIGHT;
        const ctx = canvas.getContext("2d");
        return new Promise<Blob | string>((resolve, reject) => {
            if (ctx) {
                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    CROP_WINDOW_WIDTH,
                    CROP_WINDOW_HEIGHT,
                );
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(CANVAS_EMPTY);
                    }
                    // const URL = window.URL || window.webkitURL;
                    // const fileUrl = URL.createObjectURL(blob);
                    resolve(blob as Blob);
                }, "image/png");
            } else {
                reject(CANVAS_CREATION_ERROR);
            }
        });
    } catch {
        return IMAGE_CREATION_ERROR;
    }
}
